/*
  mega-reveal, Deliverable 05: desktop mega-menu opens on hover / focus-within
  with a 120 ms intent delay, so a pointer crossing the nav on its way somewhere
  else does not flash panels open. The CSS owns the transition; this only flips
  the <details open> state.

  Click still opens and closes the panel — Dawn's <header-menu> element keeps
  handling that, plus Esc and focus return. Hover is layered on top and is
  disabled on touch and below the desktop breakpoint.
*/
(function () {
  var INTENT_IN = 120;
  var INTENT_OUT = 120;
  var desktop = window.matchMedia('(min-width: 990px)');
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  function hoverEnabled() {
    return desktop.matches && finePointer.matches;
  }

  document.querySelectorAll('details.sb-mega-menu').forEach(function (details) {
    var summary = details.querySelector('summary');
    var openTimer;
    var closeTimer;

    function open() {
      if (details.open) return;
      details.open = true;
      if (summary) summary.setAttribute('aria-expanded', 'true');
    }

    function close() {
      if (!details.open) return;
      details.open = false;
      if (summary) summary.setAttribute('aria-expanded', 'false');
    }

    details.addEventListener('mouseenter', function () {
      if (!hoverEnabled()) return;
      clearTimeout(closeTimer);
      openTimer = setTimeout(open, INTENT_IN);
    });

    details.addEventListener('mouseleave', function () {
      if (!hoverEnabled()) return;
      clearTimeout(openTimer);
      closeTimer = setTimeout(close, INTENT_OUT);
    });

    details.addEventListener('focusin', function () {
      if (hoverEnabled()) open();
    });

    details.addEventListener('focusout', function (event) {
      if (!hoverEnabled()) return;
      if (!details.contains(event.relatedTarget)) close();
    });

    // 22 Sep 2026 -- the label now has a real destination (data-mega-url), so a
    // click navigates there instead of only toggling the panel. Hover/focus
    // above already do the "let me browse this menu" job, so click no longer
    // needs to double as the disclosure trigger. A nested <a> was tried first
    // and dropped: a real click on it raced against <summary>'s native
    // toggle-on-click and lost roughly half the time (measured in-browser),
    // so navigation is driven from here instead, where it is deterministic.
    if (summary && summary.dataset.megaUrl) {
      // 26 Sep 2026 -- Dawn's global.js marks every menu <summary> role="button" (it runs first). This one
      // navigates on Enter/Space/click, so announce it as a link; aria-expanded stays, since focus still
      // opens the panel. Screen readers now read "Storage & Workspace, link, expanded".
      summary.setAttribute('role', 'link');
      summary.addEventListener('click', function (event) {
        event.preventDefault();
        window.location.href = summary.dataset.megaUrl;
      });
    }
  });
})();
